export default "__VITE_ASSET__BZz4VDl4__"